import React, { useMemo } from 'react'
import styled from 'styled-components'
import ContactSection from '~/components/ContactSection'
import MetaTags from './MetaTags'
import What from './What'
import Section2ExplainOwner from './Section2ExplainOwner'
import Section3Investment from './Section3Investment'
import Section4PaymentSchedule from './Section4PaymentSchedule'
import Section5Profit from './Section5Profit'
import Section6Compare from './Section6Compare'
import FAQ from '~/components/FAQSection'
import Section7Tax from './Section7Tax'
import CompareTable from './CompareTable'
import TableCompareMobile from './TableCompareMobile'
import Desktop from '~/components/UI/Desktop'
import Mobile from '~/components/UI/Mobile'
import { useTranslation } from '~/i18n'

const MyContainer = styled.div`
`

const HowItWorksV2: React.FC<{}> = (props: any) => {

  const { router: { query: { webview } } } = props

  const [t] = useTranslation()
  const FAQquestions = useMemo(() => ([
    {
      id: 1,
      q: t`Ai có thể đảm bảo rằng tiền của tôi gửi vào Infina là an toàn và sử dụng vào mục đích gì?`,
      a: t`Tất cả số tiền của nhà đầu tư sẽ được dùng để mua bất động sản theo sự lựa chọn của nhà đầu tư. Khách hàng có thể kiểm tra hợp đồng mua bán (hoặc sổ hồng, sổ đỏ) bất kỳ khi nào để đảm bảo rằng tài sản bạn đầu tư đã được mua và không được mang đi làm việc khác.`
    },
    {
      id: 2,
      q: t`Lợi nhuận của việc đầu tư sản phẩm Đầu tư chung Bất động sản theo phần là gì?`,
      a: t`Lợi nhuận sẽ đến từ việc bán ra nguyên căn bất động sản hoặc khi bán một phần sở hữu với giá tốt. Ngoài ra, lợi nhuận có thể đến từ chính sách cam kết lợi nhuận hoặc tiền thuê nhà (tùy thuộc vào dự án).`
    },
    {
      id: 3,
      q: t`Làm sao tôi biết được giá bán của bất động sản là bao nhiêu?`,
      a: t`Giá mua bất động sản được thể hiện trong hợp đồng mua bán với chủ đầu tư được công bố trên trang chi tiết của dự án. Ngoài ra, Infina sẽ khảo sát thị trường và cập nhật giá cho các BĐS theo từng quý.`
    },
    {
      id: 4,
      q: t`Khi nào RealStake sẽ bán nguyên căn?`,
      a: t`Thời điểm tốt nhất để bán ra căn hộ là giai đoạn nhận bàn giao căn hộ (18~24 tháng), Infina sẽ bán ra căn hộ trong giai đoạn này hoặc trước đó nếu được giá tốt.`
    }
  ]), [])

  return (
    <MyContainer>
      <MetaTags {...props} />
      <What />
      <Section2ExplainOwner />
      <Section3Investment />
      <Section4PaymentSchedule />
      <Section5Profit />
      <Section6Compare />
      <Desktop>
        <CompareTable />
      </Desktop>
      <Mobile>
        <TableCompareMobile />
      </Mobile>


      <Section7Tax />
      <FAQ content={FAQquestions} />
      <div style={{ overflow: 'hidden', height: 'auto', maxHeight: 491, marginTop: 60 }}>
        {webview !== '1' ? <ContactSection /> : null}
      </div>
    </MyContainer >
  )
}

export default HowItWorksV2
